import React, { createContext, useContext, useState, useCallback } from 'react'
import Toast from './Toast'

const ToastContext = createContext(null)

export const useToast = () => {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider')
  }
  return context
}

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([])

  const addToast = useCallback(({ type = 'info', title, message, duration = 5000 }) => {
    const id = Date.now() + Math.random()
    const toast = { id, type, title, message, duration }
    setToasts(prev => [...prev, toast])
    return id
  }, [])

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id))
  }, [])

  const showSuccess = useCallback((message, title = 'Success') => {
    return addToast({ type: 'success', title, message })
  }, [addToast])

  const showError = useCallback((message, title = 'Error') => {
    return addToast({ type: 'error', title, message })
  }, [addToast])

  const showWarning = useCallback((message, title = 'Warning') => {
    return addToast({ type: 'warning', title, message })
  }, [addToast])

  const showInfo = useCallback((message, title = 'Info') => {
    return addToast({ type: 'info', title, message })
  }, [addToast])

  const showNotification = useCallback((message, title = 'Notification') => {
    return addToast({ type: 'notification', title, message, duration: 7000 })
  }, [addToast])

  const showBroadcast = useCallback((message, title = '📢 Broadcast') => {
    return addToast({ type: 'broadcast', title, message, duration: 10000 })
  }, [addToast])

  const value = {
    addToast,
    removeToast,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showNotification,
    showBroadcast
  }

  return (
    <ToastContext.Provider value={value}>
      {children}
      {/* Toast Container */}
      <div className="fixed top-20 right-4 z-[9999] flex flex-col items-end space-y-2 pointer-events-none">
        <div className="pointer-events-auto">
          {toasts.map(toast => (
            <Toast
              key={toast.id}
              {...toast}
              onClose={removeToast}
            />
          ))}
        </div>
      </div>
    </ToastContext.Provider>
  )
}

